<template>
  <div class="main">
    <div class="container">
      <ul class="breadcrumb">
        <li>
          您所在的位置：
        </li>
        <li class="alpha hover">
          <a>首页</a>
        </li>
        <li class="alpha hover" @click="$router.push('/')">
          <a>暂停通讯工具号码网上公示</a>
        </li>
        <li class="active">
          {{$route.query.name}}
        </li>
      </ul>
      <div class="box box-default">
        <div class="case-list">
          <div class="well">
            以下通讯工具号码使用者的乱张贴、乱涂写、乱刻画、乱悬挂、乱散发等违法行为，违反了《上海市查处乱张贴乱涂写乱刻画乱悬挂乱散发规定》第五条、《上海市市容环境卫生管理条例》第二十四条第一款的规定，责令予以清除，并请从本公示之时起48小时内到短信通知中的地点接受处理，逾期不接受处理的，将依据《上海市查处乱张贴乱涂写乱刻画乱悬挂乱散发规定》第九条第一款、《上海市市容环境卫生管理条例》第二十四条第四款的规定，对以下号码予以暂停使用。特此公示。
          </div>
          <h3 class="model-title">
            <span> {{$route.query.name}}</span>
          </h3>
          <ul class="ul-list">
            <li v-for="item in list" :key="item.guid" @click="clickFn(item.guid)">
              <a>
                <span class="time">[{{ item.publicdate ? item.publicdate.split(' ')[0] : ''}}]</span>
                <span class="phone">{{ item.tel }}</span>
                <span class="adress">{{ item.penaltyorganname }}</span>
              </a>
            </li>
          </ul>
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="form.page"
              :page-size="form.limit"
              layout="prev, pager, next"
              :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getCaseInfoList} from "@/http"
export default {
  data() {
    return {
      list: [],
      total: 0,
      form: {
        page: 1,
        limit: 15,
        tel: '',
        id: ''
      }
    }
  },
  methods: {
    init() {
      getCaseInfoList(this.form).then(res => {
        this.total = res.total
        this.list = res.list
      })
    },
    clickFn(val) {
      this.$router.push({
        path: '/detail', query: {
          guid: val
        }
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.init()
    }

  },
  mounted() {
    this.form.id = this.$route.query.guid
    this.form.tel = this.$route.query.tel
    this.init()
  },
}
</script>
<style lang="less">
.main {
  .container {
    width: 1000px;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;

    .breadcrumb {
      background-color: transparent;
      font-size: 14px;
      margin-bottom: 10px;
      padding: 0 8px 10px 0;
      list-style-type: none;

      li + li:before {
        content: ">";
        color: #333;
        padding: 0 5px;
      }

      :nth-child(2):before {
        display: none;
      }

      .hover {
        cursor: pointer;
      }

      li {
        display: inline-block;

      }

      .alpha {
        a {
          color: #333;
        }
      }

      .active {
        color: #777;
      }
    }

    .box {
      border-style: solid;
      border-width: 1px;
      border-color: #D1D1D1;
      margin-bottom: 30px;

      .case-list {
        background-color: #fff;
        padding: 20px 20px 10px 20px;

        .well {
          border-radius: 0;
          line-height: 1.7;
          text-indent: 2em;
          min-height: 20px;
          padding: 19px;
          margin-bottom: 20px;
          background-color: #f5f5f5;
          border: 1px solid #e3e3e3;
          border-radius: 4px;
          -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%);
          box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%);
        }

        .model-title {
          font-size: 16px;
          margin: 0 0 20px 0;
          position: relative;
          height: 40px;
          line-height: 40px;
          color: #FFF;
        }

        .model-title span {
          position: absolute;
          left: -20px;
          height: 100%;
          width: 214px;
          text-indent: 40px;
          background: url(../../assets/img/title-background.png) right center no-repeat;
        }

        .ul-list {
          list-style-type: none;
          padding: 0;
          margin-bottom: 30px;
          min-height: 200px;

          li {
            border-bottom: 1px dashed #D1D1D1;
            padding: 12px 10px 12px 40px;
            background: url(../../assets/img/arrow.png) no-repeat 10px center;
            cursor: pointer;

            a {
              color: #337ab7;
              text-decoration: none;

              .time {
                display: inline-block;
                vertical-align: middle;
                padding-right: 10px;
              }

              .phone {
                display: inline-block;
                vertical-align: middle;
                max-width: 700px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis
              }

              .adress {
                float: right
              }
            }
          }
        }
      }
    }
  }

  .el-pagination {
    text-align: center;
  }
}

</style>
